import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=49029b0c&scoped=true&"
import script from "./ArticleDetails.vue?vue&type=script&lang=js&"
export * from "./ArticleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49029b0c",
  null
  
)

export default component.exports